import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  learnMore: {
    id: 'generic.course-card.learn-more',
    defaultMessage: 'اعرف المزيد',
    description: 'Top action label on the homepage course card.',
  },
  current: {
    id: 'generic.course-card.current',
    defaultMessage: 'مفتوح',
    description: 'Current course status label.',
  },
  startingSoon: {
    id: 'generic.course-card.starting-soon',
    defaultMessage: 'ينطلق قريبا',
    description: 'Upcoming course status label.',
  },
  openForEnrollment: {
    id: 'generic.course-card.open-for-enrollment',
    defaultMessage: 'التسجيلات مفتوحة',
    description: 'Enrollment availability label.',
  },
  startDate: {
    id: 'generic.course-card.start-date',
    defaultMessage: 'Starts: {startDate}',
    description: 'Start date.',
  },
  startedDate: {
    id: 'generic.course-card.started-date',
    defaultMessage: 'انطلق يوم: {startDate}',
    description: 'Started date.',
  },
});

export default messages;
